export enum FtpAuthenticationMode {
    Password = 1,
    PrivateKey = 2,
    PrivateKeyAndPassphrase = 3
};
